<template>
  <v-container style="padding: 0; margin: 0">
    <treeselect
      v-model="store.selectedCityId"
      :options="treeCities"
      placeholder="Select Country / City"
      :default-expand-level="0"
      :multiple="true"
      :disable-branch-nodes="true"
      class="mb-4"
    />

    <div
      ref="mapContainer"
      style="
        height: 22.375rem;
        min-height: 22.375rem;
        border-radius: 10px;
        overflow: hidden;
        border: 2.7px solid #d6d6d6;
      "
    ></div>

    <v-slider
      v-if="selectedCoords.length"
      v-model="radius"
      label="Radius"
      min="15000"
      max="70000"
      step="100"
      class="mt-4 no-border-slider"
      color="#237276"
    />
  </v-container>
</template>

<script>
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import apiClient from "@/core/buildRequest";
import { useSuperAddStore } from "@/store/superAddStore";
import { Loader } from "@googlemaps/js-api-loader";

export default {
  components: { Treeselect },

  data() {
    return {
      store: useSuperAddStore(),
      treeCities: [],
      selectedCoords: [],
      selectedNames: [],
      selectedLatLngs: [],
      radius: 15000,
      map: null,
      markers: [],
      circles: [],
      activeIndex: null,
      // يفضّل تحط المفتاح في .env
      apiKey: "AIzaSyDZjKonZH3dbzAWQL7P74hu7Pddbd76P6I",
      googleRef: null, // هنخزن فيها window.google بعد التحميل
      mapsReady: false,
    };
  },

  watch: {
    "store.selectedCityId"(newVal) {
      if (newVal) this.onCitySelected(newVal);
    },
    radius(val) {
      if (this.activeIndex !== null && this.circles[this.activeIndex]) {
        this.circles[this.activeIndex].setRadius(val);
        this.selectedLatLngs[this.activeIndex].radius = val;
        localStorage.setItem("selectedLatLngs", JSON.stringify(this.selectedLatLngs));
      }
    },
  },

  methods: {
    validate() {
      const hasValidLocation = Array.isArray(this.store.selectedCityId) && this.store.selectedCityId.length > 0;
      if (!hasValidLocation) return "Please select at least one location on the map.";
      return null;
    },
    getData() {
      return {
        selectedNames: this.selectedNames,
        selectedLatLngs: this.selectedLatLngs,
      };
    },

    async fetchCountries() {
      try {
        const response = await apiClient.get("/super-ad/countries", {
          params: { platform: "tiktok", search: "" },
        });
        this.treeCities = response.data.data.map((country) => ({
          id: country.id,
          label: country.label,
          country_code: country.country_code,
          children: country.children
            ? country.children.map((city) => ({
                id: city.id,
                region_code: city.region_code,
                label: city.label,
                platform: city.platform,
              }))
            : [],
        }));
      } catch (error) {
        console.error("Failed to load countries", error);
      }
    },

    async fetchCoordsFromGoogle(cityName, countryName = "") {
      try {
        const query = `${cityName}, ${countryName}`;
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${this.apiKey}`
        );
        const data = await response.json();
        if (data.results && data.results[0]) {
          return data.results[0].geometry.location; // {lat, lng}
        }
        return null;
      } catch (err) {
        console.error("Geocode fetch failed", err);
        return null;
      }
    },

    async onCitySelected(cityIds) {
      if (!this.mapsReady) return; // تأكد إن المكتبة اتحملت

      // امسح القديم
      this.markers.forEach((m) => m.setMap(null));
      this.circles.forEach((c) => c.setMap(null));
      this.markers = [];
      this.circles = [];
      this.selectedCoords = [];
      this.selectedNames = [];
      this.selectedLatLngs = [];

      for (let i = 0; i < cityIds.length; i++) {
        const id = cityIds[i];
        for (const country of this.treeCities) {
          const city = country.children.find((c) => c.id === id);
          if (city) {
            const coords = await this.fetchCoordsFromGoogle(city.label, country.label);
            if (coords) {
              const marker = new this.googleRef.maps.Marker({
                position: coords,
                map: this.map,
                draggable: true,
              });

              const circle = new this.googleRef.maps.Circle({
                map: this.map,
                center: coords,
                radius: this.radius,
                fillColor: "#FF0000",
                fillOpacity: 0.2,
                strokeWeight: 0,
              });

              marker.addListener("dragend", (event) => {
                const newLatLng = {
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng(),
                };
                circle.setCenter(newLatLng);
                this.selectedCoords[i] = newLatLng;
                this.selectedLatLngs[i] = { ...newLatLng, radius: this.radius };
                localStorage.setItem("selectedLatLngs", JSON.stringify(this.selectedLatLngs));
              });

              marker.addListener("click", () => {
                this.activeIndex = i;
              });

              this.markers.push(marker);
              this.circles.push(circle);
              this.selectedCoords.push(coords);
              this.activeIndex = this.selectedCoords.length - 1;

              // بناء selectedNames
              let existingCountry = this.selectedNames.find((c) => c.id === country.id);
              const cityData = {
                id: city.id,
                region_code: city.region_code,
                label: city.label,
                platform: city.platform,
              };

              if (existingCountry) {
                const alreadyExists = existingCountry.children.find((child) => child.id === city.id);
                if (!alreadyExists) existingCountry.children.push(cityData);
              } else {
                this.selectedNames.push({
                  id: country.id,
                  label: country.label,
                  country_code: country.country_code,
                  children: [cityData],
                });
              }

              this.selectedLatLngs.push({ lat: coords.lat, lng: coords.lng, radius: this.radius });
            }
            break;
          }
        }
      }

      if (this.selectedCoords.length > 0) {
        this.map.setCenter(this.selectedCoords[0]);
        this.map.setZoom(7);
      }

      localStorage.setItem("selectedNames", JSON.stringify(this.selectedNames));
      localStorage.setItem("selectedLatLngs", JSON.stringify(this.selectedLatLngs));
    },
  },

  async mounted() {
    await this.fetchCountries();

    // حمّل Google Maps أولاً
    const loader = new Loader({
      apiKey: this.apiKey,
      version: "weekly",
      // لو محتاج Places أو Drawing زودها هنا:
      libraries: [], // ["places", "drawing"]
    });

    try {
      await loader.load();
      this.googleRef = window.google;
      this.mapsReady = true;

      // أنشئ الخريطة بعد التحميل
      this.map = new this.googleRef.maps.Map(this.$refs.mapContainer, {
        center: { lat: 26.8206, lng: 30.8025 },
        zoom: 5,
        mapTypeControl: false,
        streetViewControl: false,
      });
    } catch (e) {
      console.error("Failed to load Google Maps JS API", e);
      // لو شوفت BillingNotEnabledMapError: لازم تفعّل الفوترة للمفتاح
    }
  },
};
</script>


<style scoped>
.no-border-slider {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
</style>
